// frontend/src/utils/navBarHelpers.ts
import React from 'react';
import { toast } from 'react-toastify';
import { ROUTE_AUTH_LOGOUT } from '../../config/routes/routeConfig';
import { fetchWithAuth } from './helpers/fetchUtils';
import { logger } from './logger';
import { Area } from '../../types/common.types';
import { UserPermissions } from '../../types/user.types';

type NavigateFunction = (path: string, options?: { replace?: boolean }) => void;
type SetSelectedOption = React.Dispatch<React.SetStateAction<string | null>>;
type ClearUserData = () => void;

export const handleLogout = async (
	setSelectedOption: SetSelectedOption,
	navigate: NavigateFunction,
	clearUserData: ClearUserData
): Promise<void> => {
	try {
		const response = await fetchWithAuth(ROUTE_AUTH_LOGOUT, {
			method: 'POST',
		});

		if (response.ok) {
			// Limpiar estado local
			setSelectedOption(null);
			clearUserData();

			// Navegar al login sin reload
			navigate('/', { replace: true });

			toast.success('Sesión cerrada exitosamente', {
				autoClose: 2000,
			});
		} else {
			const errorMsg = 'Error al cerrar sesión';
			logger.error('Logout failed', { status: response.status });
			toast.error(errorMsg, {
				autoClose: 4000,
			});
		}
	} catch (error) {
		logger.error('Logout error', { error });
		toast.error('No se pudo cerrar sesión. Por favor, inténtelo de nuevo.', {
			autoClose: 4000,
		});
	}
};

export const getHasESGPermissions = (
	area: Area | Area[] | null | undefined,
	permissions: UserPermissions | null | undefined
): boolean =>
	Array.isArray(area) &&
	area.includes('ESG') &&
	!!permissions &&
	Object.values(permissions).some((perm) => perm.ver && perm.editar);

export const getFilteredOptions = (
	area: Area | Area[] | null | undefined,
	hasESGPermissions: boolean,
	areaOptions: Record<string, string[]>
): string[] =>
	Array.isArray(area)
		? Array.from(
				new Set(
					area.flatMap((a) => {
						const options = [...(areaOptions[a] || [])];
						if (a === 'ESG' && hasESGPermissions) {
							options.push('processes');
						}
						return options;
					})
				)
		  )
		: areaOptions[area as string] || [];
